import i18n from './index';

const LOCALE_MAP = {
  tr: 'tr-TR',
  ru: 'ru-RU'
};

export const getActiveLocale = (language = i18n.language) => {
  return LOCALE_MAP[language] || LOCALE_MAP.tr;
};

export const formatLocalizedDate = (dateValue, language = i18n.language) => {
  if (!dateValue) return '-';

  let date;

  if (dateValue && typeof dateValue.toDate === 'function') {
    date = dateValue.toDate();
  } else if (dateValue instanceof Date) {
    date = dateValue;
  } else {
    date = new Date(dateValue);
  }

  if (isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleDateString(getActiveLocale(language));
};

export const formatLocalizedLongDate = (dateValue, language = i18n.language) => {
  if (!dateValue) return '-';

  let date;

  if (dateValue && typeof dateValue.toDate === 'function') {
    date = dateValue.toDate();
  } else if (dateValue instanceof Date) {
    date = dateValue;
  } else {
    date = new Date(dateValue);
  }

  if (isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleDateString(getActiveLocale(language), {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const formatLocalizedPrice = (price, language = i18n.language) => {
  const num = parseFloat(price || 0);

  return num.toLocaleString(getActiveLocale(language), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const getMonthAbbreviation = (monthIndex, language = i18n.language) => {
  const date = new Date(2024, monthIndex, 1);
  return date.toLocaleDateString(getActiveLocale(language), { month: 'short' });
};

export const localizeMonthlyChartData = (data, language = i18n.language) => {
  if (!Array.isArray(data)) return [];

  return data.map((item, index) => ({
    ...item,
    month: getMonthAbbreviation(index, language)
  }));
};
